import omitBy from 'lodash/omitBy'
import isNil from 'lodash/isNil'
import merge from 'lodash/merge'
import Vue from 'vue'
import VuePlyr from 'vue-plyr'
import Ncs from 'ncs'
import config from '../search/ncs_config'
import PageSelector from './PageSelector'
import MatchingExpressionsPageSelector from './MatchingExpressionsPageSelector'
import KwicHeader from './KwicHeader'
import ContextResult from './ContextResult'
import ContextTextHeader from './ContextTextHeader'

Vue.use(VuePlyr, {plyr: {fullscreen: {enabled: false}}, emit: ['ended']})

const components = {
  ...Ncs.defaultComponents,
  NcsPageSelector: PageSelector,
  NcsMatchingExpressionsPageSelector: MatchingExpressionsPageSelector,
  NcsKwicResultHeader: KwicHeader,
  NcsContextResult: ContextResult,
  NcsContextTextHeader: ContextTextHeader,
}

function csvElementFields(document, text, elements, matches) {
  return omitBy({
    [this.$i18n.t('result.context.header.document.subcorpus')]: document.subcorpus,
    [this.$i18n.t('result.context.header.text.hablante')]: text.hablante,
    [this.$i18n.t('result.context.header.text.rol')]: text.rol,
    [this.$i18n.t('result.context.header.text.sexo')]: text.sexo,
    [this.$i18n.t('result.context.header.text.edad')]: text.edad,
    [this.$i18n.t('result.context.header.text.estudios')]: text.estudios,
  }, v => v === '' || isNil(v))
}

Vue.use(Ncs, {config: merge(gon.config, config), components, csvElementFields})

export {Vue, Ncs}
